import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { Bau365DataAccessAuthenticationModule } from '@planone/bau365/data-access-authentication';
import { Bau365UtilUserDataModule } from '@planone/bau365/util-user-data';
import { SharedUtilDownloadsModule } from '@planone/shared/util-downloads';

import { BusinessCardResolver } from './resolver/business-card.resolver';
import { BusinessCardService } from './service/business-card.service';
import { BusinessCardEffects } from './state/business-card.effects';
import { BusinessCardFacade } from './state/business-card.facade';
import * as fromBusinessCard from './state/business-card.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromBusinessCard.BUSINESS_CARD_FEATURE_KEY, fromBusinessCard.reducer),
    EffectsModule.forFeature([BusinessCardEffects]),
    Bau365DataAccessAuthenticationModule,
    Bau365UtilUserDataModule,
    SharedUtilDownloadsModule,
  ],
  providers: [BusinessCardService, BusinessCardFacade, BusinessCardResolver],
})
export class Bau365DataAccessBusinessCardModule {}
